import React, { useMemo } from 'react';
import clsx from 'clsx';
import { Box, Button, IconButton, Icons, Stack } from '@curves/ui-base';
import { REFERENCE_KIND_PRODUCT, buildCategoryPathMap, getItemDisplayName, getItemKey } from './CampaignEdit.config';

/**
 * 名單已選項目列
 * - 左側種類徽章，中間上層路徑與名稱分兩行，右側移除鈕；分類樹找不到時退回原名稱
 */
const LimitItem = ({ item, pathMap, onRemove }) => {
    const isProduct = item.referenceKind === REFERENCE_KIND_PRODUCT;
    const path = isProduct ? null : pathMap.get(item.referenceID);
    const parentPath = path && path.length > 1 ? path.slice(0, -1).join(' › ') : '';
    const name = path ? getItemDisplayName({ ...item, displayName: path[path.length - 1] }) : getItemDisplayName(item);
    return (
        <Box className={clsx('campaign-limit-item', item.isDeleted && 'campaign-limit-item--deleted')}>
            <span className="campaign-limit-item__kind">{isProduct ? '商品' : '分類'}</span>
            <Box className="campaign-limit-item__text">
                {parentPath && <Box className="campaign-limit-item__path">{parentPath}</Box>}
                <Box className="campaign-limit-item__name">{name}</Box>
            </Box>
            <IconButton size="small" className="campaign-limit-item__remove" onClick={() => onRemove(item)}>
                <Icons.Close fontSize="small" />
            </IconButton>
        </Box>
    );
};

/**
 * 單一名單（白名單或黑名單）
 * - 標題列右側放加入按鈕，由 CampaignDialogBox 開啟視窗；已加入項目以清單列排在下方，可移除
 */
const CampaignLimitList = ({ title, description, listKey, items, categoryTrees, dialogRef, onRemove }) => {
    // 分類 ID 對應的完整路徑，清單列用來顯示階層
    const pathMap = useMemo(() => buildCategoryPathMap(categoryTrees), [categoryTrees]);

    return (
        <Box className="campaign-limit-list">
            <Box className="campaign-limit-list__header">
                <Box>
                    <Box className="campaign-limit-list__title">
                        {title}
                        {items.length > 0 && <span className="campaign-limit-list__count">{`${items.length} 項`}</span>}
                    </Box>
                    <Box className="campaign-limit-list__description">{description}</Box>
                </Box>
                <Stack spacing={1}>
                    <Button size="small" variant="outlined" color="primary" startIcon={<Icons.Plus fontSize="small" />} onClick={() => dialogRef.current.openCategoryDialog({ listKey, title: `${title}：加入分類` })}>
                        分類
                    </Button>
                    <Button size="small" variant="outlined" color="primary" startIcon={<Icons.Plus fontSize="small" />} onClick={() => dialogRef.current.openProductSearchDialog({ listKey, title: `${title}：加入單品` })}>
                        單品
                    </Button>
                </Stack>
            </Box>
            <Box className="campaign-limit-list__items">
                {items.length === 0 && <Box className="campaign-limit-list__empty font-color-3">尚未加入任何項目</Box>}
                {items.map(item => (
                    <LimitItem key={getItemKey(item)} item={item} pathMap={pathMap} onRemove={onRemove} />
                ))}
            </Box>
        </Box>
    );
};

export default CampaignLimitList;
